export const environment = {
  production: false,
  // apiUrl: "https://environer-dev.une.edu.au/web-api",
  // apiUrl: "https://casi-dev.une.edu.au/db-manager",
  apiUrl: "https://reflexis-dev.une.edu.au/web-api",
  // socketUrl: "https://casi-dev.une.edu.au"
  socketUrl: "https://reflexis-dev.une.edu.au"
};
